import { PageLayout } from '@/components/PageLayout';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import { useContext } from 'react';
import { NavContext } from '@/components/NavContext';
import { useMobile } from '@/util';
import SidebarNavigation from '@/components/SidebarNavigation';
import { profileSidebar } from '../../constants/sidebar.constants';
import BreadCrumbsHeader from '@/components/BreadCrumbsHeader';

function ProfilePage() {
  const { t } = useTranslation();
  const { collapsed, navDisabled, submenu } = useContext(NavContext);
  const isMobile = useMobile();
  const showNav = !navDisabled && ((submenu && !collapsed) || !isMobile);
  const showContent = collapsed || !isMobile;

  return (
    <PageLayout>
      {showNav && (
        <PageLayout.Sidebar>
          <SidebarNavigation items={profileSidebar} />
        </PageLayout.Sidebar>
      )}
      <div
        className={`${
          showContent ? '' : 'hidden'
        } mx-auto min-h-[100vh] w-full max-w-6xl lg:min-h-[calc(100vh_-_150px)]`}
      >
        <PageLayout.Content>
          {!isMobile && <BreadCrumbsHeader />}
          <Outlet />
        </PageLayout.Content>
      </div>
    </PageLayout>
  );
}

export default ProfilePage;
